import { Operation } from './../model/requests-model';
import { Injectable } from '@angular/core';
import { OperationsQueryDto } from '@app/requests/model/requests-model';
import { CommonDataDTO } from '../model/combos-model';
import {
  REQUEST_APPROVED,
  REQUEST_CANCELLED,
  REQUEST_CONDTIONATED_VALIDATION,
  REQUEST_DENIED,
  REQUEST_PAID_PENDING_VALIDATION,
  REQUEST_PENDING,
  REQUEST_PENDING_PAYMENT_INCIDENT,
  REQUEST_REGULARISE_PAID_VALIDATED,
  REQUEST_SIGNED,
  REQUEST_STUDYING,
} from '@app/@core/constants/requests.constants';

@Injectable()
export class PanelStore {
  private filterStatus: OperationsQueryDto = {
    state: 'TS',
    initialDate: '',
    finalDate: '',
  };

  private operationToShow: Operation;

  public setFilterStatus(status: OperationsQueryDto) {
    this.filterStatus = status;
  }

  public getFilterStatus(): OperationsQueryDto {
    return this.filterStatus;
  }

  public setOperationToShow(operation: Operation) {
    this.operationToShow = operation;
    localStorage.setItem('operationToShow', JSON.stringify(operation));
  }

  public getOperationToShow(): Operation {
    if (this.operationToShow === null || this.operationToShow === undefined) {
      this.operationToShow = JSON.parse(localStorage.getItem('operationToShow'));
      return this.operationToShow;
    } else {
      return this.operationToShow;
    }
  }

  public getStatusById(id: string): CommonDataDTO {
    let estado: CommonDataDTO;
    switch (id) {
      case REQUEST_APPROVED:
        estado = { id: REQUEST_APPROVED, value: 'request.status.approve' };
        break;
      case REQUEST_PENDING:
        estado = { id: REQUEST_PENDING, value: 'request.status.pending' };
        break;
      case REQUEST_STUDYING:
        estado = { id: REQUEST_STUDYING, value: 'request.status.study' };
        break;
      case REQUEST_DENIED:
        estado = { id: REQUEST_DENIED, value: 'request.status.denied' };
        break;
      case REQUEST_REGULARISE_PAID_VALIDATED:
        estado = { id: REQUEST_REGULARISE_PAID_VALIDATED, value: 'request.status.formalise' };
        break;
      //TODO: REVISAR ESTE CASO Y EL SIGUIENTE CUANDO HYAI CAMBIE EL DISEÑO
      case '95':
        estado = { id: '95', value: 'request.status.cancel' };
        break;
      case 'PV':
        estado = { id: 'PV', value: 'PENDIENTES DE VALIDACION' };
        break;
      case '15':
        estado = { id: '15', value: 'request.status.pending.bug' };
        break;
      case 'PF':
        estado = { id: 'PF', value: 'request.status.signed' };
        break;
      case '35':
        estado = { id: '35', value: 'request.status.conditioned.pending' };
        break;
      default:
        console.error('No se ha encontrado estado de solicitudes');
        break;
    }
    console.log('status', estado);
    return estado;
  }

  public getStatusByValue(value: string): CommonDataDTO {
    let estado: CommonDataDTO;
    switch (value) {
      case 'APROBADAS':
        estado = { id: 'PA', value: 'request.status.approve' };
        break;
      case 'PENDIENTES DE DATOS':
        estado = { id: '00', value: 'request.status.pending' };
        break;
      case 'EN ESTUDIO':
        estado = { id: 'PE', value: 'request.status.study' };
        break;
      case 'CONDICIONADA PENDIENTE DE FORMALIZACION':
        estado = { id: '35', value: 'request.status.conditioned.pending' };
        break;
      case 'DENEGADAS':
        estado = { id: 'DN', value: 'request.status.denied' };
        break;
      case 'FORMALIZADAS ABONADAS Y VALIDADAS':
        estado = { id: '90', value: 'request.status.formalise' };
        break;
      //TODO: REVISAR ESTE CASO Y EL SIGUIENTE CUANDO HYAI CAMBIE EL DISEÑO
      case 'ANULADAS':
        estado = { id: '95', value: 'request.status.cancel' };
        break;
      case 'PENDIENTES DE VALIDACION':
        estado = { id: 'PV', value: 'PENDIENTES DE VALIDACION' };
        break;
      case 'SOLICITUDES PENDIENTES DE PAGO POR INCIDENCIAS':
        estado = { id: '15', value: 'request.status.pending.bug' };
        break;
      case 'FIRMADAS':
        estado = { id: 'PF', value: 'request.status.signed' };
        break;
      case 'CONDICIONADAS PENDIENTES DE FORMALIZAR':
        estado = { id: '35', value: 'request.status.conditioned.pending' };
        break;
      default:
        console.error('No se ha encontrado estado de solicitudes');
        break;
    }
    // console.log(estado)
    return estado;
  }
}

// private operationList = new BehaviorSubject<Operation[]>([]);
// public operationList$ = this.operationList.asObservable();
